import { ApiHelper, ApiHelperWithData, ApiResponseWithData, BaseRequest, splitParams } from '..';
import { GridColumnInsert, GridFilterInsert, GridList, Lock } from '../model';

/**
 * clover framework 코드 API
 */
export class TmpMigApi {
  private withData: ApiHelperWithData;

  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  /**
   * 그리드 목록 조회
   */
  callFunction = (
    params: {
      code: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ result: number }>> => {
    const url = '/apis/data-mig/run';
    return this.withData.postJson(url, ...splitParams(params));
  };
}
